// Flags are read at CALL time (not module-eval) so `vi.stubEnv` in tests takes effect
// and the client route/nav/panel see the current value. Client-side flags REQUIRE the
// `VITE_` prefix to inline into the bundle (RECONCILIATION 10).
export const isPortalEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_PORTAL === 'true';

export const isPortalListsEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_PORTAL_LISTS === 'true';

// REN-516 (Sree, 2026-11-03: members get one simple "your events" page, REN-513):
// the invites and curated-lists panels stay in the code but render only when this
// flag is explicitly 'true'. Absent (production today) = both panels off.
export const isPortalExtrasEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_PORTAL_EXTRAS === 'true';

// A2: an absolute https:// link — NOT '#', empty, or '/login'. The founder swaps this for
// the real App Store / TestFlight / universal link (Open question 3).
export const OPEN_IN_APP_URL = 'https://letsrendezvous.co/app';

// REN-514/REN-517 (Sree, 2026-11-03: one simple "your events" page, REN-513): when
// 'true', /portal shows the member's trips and nights (from the member-events read)
// and the new non-member and pending copy. Absent (production today) = the portal
// renders exactly as before. The server read has its own flag, member_events_web.
export const isMemberEventsPageEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_MEMBER_EVENTS_PAGE === 'true';
